/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stock_Out_Lot_RequiredInputs */

const vi_stock_out_lot_required = /** @type {(inputs: Stock_Out_Lot_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa chọn lô`)
};

/**

* @param {Stock_Out_Lot_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_lot_required = /** @type {((inputs?: Stock_Out_Lot_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Lot_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_lot_required(inputs)
});